import { Box, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import HeaderLabelValue from "../../unit/HeaderLabelValue";
import formatCurrency from "../../unit/formatCurrency";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomOverrideFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [overrideOption, setOverrideOption] = React.useState("");
  const [overrideAmount, setOverrideAmount] = React.useState("");
  const [overrideRate, setOverrideRate] = React.useState(
    record?.rateRecommendation ? record.rateRecommendation : record.iRate
  );
  const [overrideTerm, setOverrideTerm] = React.useState(
    record?.termRecommendation && parseInt(record.termRecommendation) > 0
      ? record.termRecommendation
      : record.iNoteTerm
      ? record.iNoteTerm
      : record.termSubmit
  );
  const [showCounterSection, setShowCounterSection] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  const formatRate = (num) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };
  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record.rateData[i],
      });
    }
  }
  const defautTermsList = [];
  if (record.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: record.termsData[i],
      });
    }
  }

  const defautPaymentFreqList = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].bbkey,
        value: record.paymentFrequencyData[i].name,
      });
    }
  }

  let defaultOverrideList = [];
  if (record.sSubType == "car") {
    if (record.sRecommendation == "Declined") {
      defaultOverrideList = [
        { label: "Select", value: "" },
        { label: "Pre-Approved", value: "approve" },
      ];
    } else {
      defaultOverrideList = [
        { label: "Select", value: "" },
        { label: "Decline", value: "decline" },
      ];
    }
  } else {
    if (record.sRecommendation == "Declined") {
      if (record.sLoanType != "account") {
        defaultOverrideList = [
          { label: "Select", value: "" },
          { label: "Counter", value: "counter" },
          { label: "Approve", value: "approve" },
        ];
      } else {
        defaultOverrideList = [
          { label: "Select", value: "" },
          { label: "Approve", value: "approve" },
        ];
      }
    } else if (record.sRecommendation == "Approved") {
      if (record.sLoanType != "account") {
        defaultOverrideList = [
          { label: "Select", value: "" },
          { label: "Decline", value: "decline" },
          { label: "Counter", value: "counter" },
        ];
      } else {
        defaultOverrideList = [{ label: "Decline", value: "decline" }];
      }
    } else {
      if (record.sLoanType != "account") {
        defaultOverrideList = [
          { label: "Select", value: "" },
          { label: "Decline", value: "decline" },
          { label: "Counter", value: "counter" },
          { label: "Approve", value: "approve" },
        ];
      } else {
        defaultOverrideList = [
          { label: "Select", value: "" },
          { label: "Decline", value: "decline" },
          { label: "Approve", value: "approve" },
        ];
      }
    }
  }

  return (
    <React.Fragment>
      <Button
        id="btn-application-override"
        label="Override"
        color="warning"
        variant="contained"
        size="medium"
        sx={{
          marginLeft: "10px",
          width: "120px",
          color: "#e9fce7",
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-override"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const notes = formJson.notes;
            formJson["rationale"] = notes;

            const reqUrl = `applications/actions/review/overrideproceed`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });

            if (response && response.status == "200") {
              successNotify("Data saved successfully");
              handleClose();
              if (props.cb) {
                props.cb("To Notify");
              }
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Override" />
        </DialogTitle>
        <DialogContent>
          <Box>
            {/* <DialogContentText></DialogContentText> */}
            <DialogApplicationBaseInfo appId={appId} record={record} />
            <Grid container sx={{ mb: 0, pb: 0 }}>
              <Grid item xs={12} sx={{ mb: 1 }}>
                <Typography variant="h6" gutterBottom>
                  Recommendation :&nbsp;
                  {record.sRecommendation ? record.sRecommendation : ""}
                </Typography>
              </Grid>

              <Grid item xs={12} container>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Amount" />
                </Grid>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Term" />
                </Grid>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Interest Rate" />
                </Grid>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Payment Frequency" />
                </Grid>
              </Grid>

              <Grid item xs={12} container>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelValue
                    value={formatCurrency(
                      record.amountRecommendation
                        ? record.amountRecommendation
                        : record.amountSubmit
                    )}
                    textAlign="right"
                  />
                </Grid>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelValue
                    value={
                      record?.termRecommendation &&
                      parseInt(record.termRecommendation) > 0
                        ? record.termRecommendation
                        : record.iNoteTerm
                        ? record.iNoteTerm
                        : record.termSubmit
                    }
                    textAlign="right"
                  />
                </Grid>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelValue
                    value={
                      record?.rateRecommendation
                        ? record.rateRecommendation
                        : record.iRate
                    }
                    textAlign="right"
                  />
                </Grid>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelValue
                    value={record?.sPaymentFrequency}
                    textAlign="right"
                  />
                </Grid>
              </Grid>

              <Grid
                sx={{
                  mb: 1,
                  mt: 1,
                  pt: 1,
                  borderTop: "1px solid #e9fce7",
                }}
                container
              >
                <Grid item xs={5} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Override Decision" required={true} />
                </Grid>
                <Grid item xs={5}>
                  <CustomSelect
                    fullWidth={true}
                    variant="outlined"
                    id="option"
                    name="option"
                    optionlist={defaultOverrideList}
                    value={overrideOption}
                    required={true}
                    onChange={(e) => {
                      if (e.target.value == "counter") {
                        setShowCounterSection(true);
                      } else {
                        setShowCounterSection(false);
                      }
                      setOverrideOption(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
              {showCounterSection && (
                <>
                  <Grid item xs={12} spacing={1} container>
                    <Grid item xs={4} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Final Amount" required={true} />
                    </Grid>
                    <Grid item xs={4} sx={{ pt: 1 }}>
                      <HeaderLabelTitle title="Final Rate" required={true} />
                    </Grid>

                    <Grid item xs={4} sx={{ pt: 1 }}>
                      <HeaderLabelTitle
                        title="Final Term (Months)"
                        required={true}
                      />
                    </Grid>
                  </Grid>
                  <Grid sx={{ mb: 2 }} spacing={1} container>
                    {/* set Final Amount, Final Rate, Final Term */}
                    <Grid item xs={4} sx={{ pt: 1 }}>
                      <TextField
                        fullWidth
                        type="text"
                        variant="outlined"
                        id="overrideamount"
                        name="overrideamount"
                        required
                        sx={{ mt: 0 }}
                        value={overrideAmount}
                        onChange={(e) => setOverrideAmount(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4} sx={{ pt: 1 }}>
                      <CustomSelect
                        fullWidth={true}
                        variant="outlined"
                        id="overriderate"
                        name="overriderate"
                        optionlist={defautRateOptionList}
                        required
                        value={overrideRate}
                        onChange={(e) => setOverrideRate(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4} sx={{ pt: 1 }}>
                      <CustomSelect
                        fullWidth={true}
                        variant="outlined"
                        id="overrideterm"
                        name="overrideterm"
                        optionlist={defautTermsList}
                        required
                        value={overrideTerm}
                        onChange={(e) => setOverrideTerm(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              <Grid sx={{ mb: 1 }} container>
                <HeaderLabelTitle title="Add Note (Max 150 Characters)" />
              </Grid>
              <Grid sx={{ mb: 1 }} container>
                <TextField
                  id="notes"
                  name="notes"
                  placeholder="Notes"
                  multiline={true}
                  minRows={2}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Override" color={"warning"} />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
